import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-spriced-footer',
  standalone: true,
  templateUrl: './spriced-footer.component.html',
  styleUrl: './spriced-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpricedFooterComponent {
  readonly logoSrc = this.resolveLogo();
  readonly logoAlt = this.resolveLogoAlt();
  readonly copyrightText = '© 2011 SIM Advisory Inc.  All Rights Reserved.';

  private resolveLogo(): string {
    const config = environment as Record<string, any>;
    const useAlternate = config['USE_ALT_SIDENAV'] === true || config['USE_ALT_SIDENAV'] === 'true';
    if (useAlternate) return String(config['ALT_SECONDARY_LOGO_SRC'] || config['ALT_COMPANY_LOGO_SRC'] || '').trim();
    return String(config['COMPANY_LOGO_SRC'] || config['DEFAULT_COMPANY_LOGO'] || '').trim();
  }

  private resolveLogoAlt(): string {
    const config = environment as Record<string, any>;
    return String(config['COMPANY_LOGO_TEXT'] || 'SIM Advisory').trim();
  }
}
